import { render, staticRenderFns } from "./DiabetesRiskCheckQuiz.vue?vue&type=template&id=ab3c3f66"
import script from "./DiabetesRiskCheckQuiz.vue?vue&type=script&lang=js"
export * from "./DiabetesRiskCheckQuiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports